import {
    buildConversionData,
    buildPreConversionData,
    isSkyscanner,
    sendConversionEvent,
    sendPreConversionEvent
} from "./skyscanner";

// Same local ready() helper the rebuilt packs use (see
// packs/desktop/step2.js and step3.js) -- this body was already pure
// DOM, only its $(fn) wrapper was jQuery.
function ready(fn) {
    if (document.readyState !== "loading") fn();
    else document.addEventListener("DOMContentLoaded", fn);
}

// skyscanner.js's stringToFloat() does string.match(/\d+/g).join(""), which
// throws on anything with no digits in it (null, "", a label-only element).
// Every caller here routes its price through this first, so a price we
// cannot read sends the event with "0" -- which that function special-cases
// -- instead of throwing the event away.
function priceOrZero(value) {
    return value && /\d/.test(value) ? value : "0";
}

ready(function () {
    if(!isSkyscanner()) return false;

    const currency = document.getElementsByTagName('body')[0].getAttribute('currency');

    // booking page -> conversion event
    const booking = document.getElementsByClassName("skyscanner-booking-information")[0];
    // const booking = document.getElementById("booking-information");
    if (booking) {
        const payload = buildConversionData(
            booking.getAttribute("data-adult-number"),
            booking.getAttribute("data-cabin-class"),
            booking.getAttribute("data-child-number"),
            booking.getAttribute("data-conversion-id"),
            currency,
            booking.getAttribute("data-fare-basis-codes"),
            booking.getAttribute("data-flight-fare"),
            booking.getAttribute("data-infant-number"),
            booking.getAttribute("data-legs"),
            booking.getAttribute("data-marketing-carriers"),
            booking.getAttribute("data-payment-method"),
            booking.getAttribute("data-route-type"),
            booking.getAttribute("data-transaction-total")
        );
        return sendConversionEvent(payload);
    }

    // Step2
    const step2 = document.getElementsByClassName("skyscanner-step2-data")[0];
    // const step2 = document.getElementById("step-2-data");
    if (step2) {
        const withinTolerance = document.getElementsByClassName("skyscanner-price-tolerance")[0];
        // const withinTolerance = document.getElementById("skyscanner-price-tolerance");
        // Read through a null check rather than straight off [0].innerText:
        // a missing .total-amount used to throw here, which lost the event
        // AND killed everything after it in this handler. The element is
        // rendered on every step2 (front/step2/_summery.html.erb, which the
        // booking form renders unconditionally), so this is belt and braces
        // -- but it is the kind of belt this file has already needed once.
        const total = document.getElementsByClassName('total-amount')[0];
        const payload = buildPreConversionData(
            currency,
            step2.getAttribute("data-fare-basis-codes"),
            step2.getAttribute("data-marketing-carriers"),
            priceOrZero(total && total.innerText),
            withinTolerance ? "booking-page" : "recheckout-page"
        );
        return sendPreConversionEvent(payload);
    }

    // step1 results -> dayview pre conversion event
    //
    // Deferred to the step1:results-loaded event (dispatched by
    // controllers/step1_results_controller.js once its first fetch has been
    // rendered): the rebuilt results list is loaded over AJAX after this
    // handler runs, so there is nothing to read at this point.
    //
    // This is the event the legacy mobile tree used to send from
    // dep/skyscanner/mobile_triggers.js (its .itinerary-mobile /
    // .skyscanner-your-choice branch). Mobile traffic for flygcity,
    // flysmarter and aob now renders these templates instead (see
    // RenderHelper::MOBILE_CUTOVER_LAYOUTS), so without this the dayview
    // stage stopped being reported at all; desktop never reported it.
    // Same payload rule as mobile's: the clicked itinerary's own fare basis
    // codes, carriers and party total when it is in the list, otherwise the
    // bare "we showed a dayview" event.
    const step1 = document.querySelector("[data-step1-results-target='results']");
    if (step1) {
        document.addEventListener("step1:results-loaded", function () {
            const choice = document.querySelector("[data-meta-choice]");
            const payload = buildPreConversionData(
                currency,
                choice ? choice.getAttribute("data-fare-basis-codes") : '',
                choice ? choice.getAttribute("data-marketing-carriers") : '',
                choice ? priceOrZero(choice.getAttribute("data-meta-total-price")) : '0',
                'dayview-page'
            );
            sendPreConversionEvent(payload);
        }, { once: true });
        return true;
    }

    // homepage -> pre conversion event
    const homepage = document.getElementsByClassName("page_front")[0];
    if (homepage) {
        const payload = buildPreConversionData(
            currency,
            '',
            '',
            '0',
            'home-page'
        );
        return sendPreConversionEvent(payload);
    }
});
